module.exports = __webpack_public_path__ + "img/screenshot1.d5136ded.png";